// extracted by mini-css-extract-plugin
export var root = "blog-post-preview-list-module--root--1LTV4";
export var headline = "blog-post-preview-list-module--headline--2RxTp";
export var grid = "blog-post-preview-list-module--grid--XQv0p";
export var container = "blog-post-preview-list-module--container--dxx0T";
export var browseMoreNav = "blog-post-preview-list-module--browseMoreNav--1fga1 typography-module--small--1SU-S";
export var blogList = "blog-post-preview-list-module--blogList--3bHY_";